<script setup lang="ts">
import { ref, toValue } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToast } from 'primevue/usetoast';
import { UserStore } from '@/store/UserStore';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';

const { t } = useI18n({ useScope: 'global' });
const userStore = UserStore();
const toast = useToast();
const userName = ref('');
const password = ref('');
const isLoading = ref(false);

const emits = defineEmits<{ userLogged: [] }>();

const login = async () => {
  isLoading.value = true;
  try {
    const response = await userStore.handleGetUserSecure(toValue(userName), toValue(password));
    if (response) {
      emits('userLogged');
    } else {
      toast.add({ severity: 'error', summary: '', detail: t('notification.invalid_username_pass'), life: 5000 });
    }
  } finally {
    isLoading.value = false;
  }
};
</script>

<template>
  <div class="text-center">
    <form class="login-field">
      <label for="username" class="block font-bold mb-2">{{ $t('common.user_name') }}</label>
      <InputText id="username" type="text" :placeholder="$t('common.user_name')" class="input-login" v-model="userName" autocomplete="on" />
      <label for="password" class="block font-bold mb-2">{{ $t('common.password') }}</label>
      <Password inputId="password" toggleMask v-model="password" :feedback="false" :placeholder="$t('common.password')" class="input-login password-input cursor-pointer" inputClass="w-full"></Password>
      <div>
        <Button class="vacv-btn" id="submit-user" :label="$t('common.buttons.submit')" @click="login()" :disabled="!userName || !password" :loading="isLoading" />
      </div>
    </form>
  </div>
</template>
